module.exports = __webpack_public_path__ + "img/public/SiteIcons/priceHoverIcon.svg?88c55d31";